export const TRACTOR_BOOKING_LOADED = "tractorBookingLoad"
export const TRACTOR_BOOKING_DONE = "tractorBookingDone"
export const TRACTOR_BOOKING_UPDATED = "tractorBookingUpdated"
export const TRACTOR_BOOKING_SENT_FOR_APPROVAL = "tractorBookingSentForApproval"
export const TRACTOR_BOOKING_STATUS_UPDATE_FROM_JD = "tractorBookingStatusUpdateFromJD"
export const TRACTOR_COLUMN_UPDATED = "tractorColumnUpdated"
export const TRACTOR_COLUMN_UPDATED_FOR_INSPECTION = "tractorColumnUpdatedForInspection"
export const TRACTOR_PLANNING_DONE = "tractorPlanningDone"
export const TRACTOR_ORIGIN_TIME = "tractorOriginTime"
export const TRACTOR_INSERT_DROPDOWN_DATA = "tractorInsertDropdownData"
export const TRACTOR_DELETE_SUBROW = "tractorDeleteSubrow"
export const TRACTOR_BULK_BOOKING_DONE = "tractorBulkBookingDone"
export const TRACTOR_UPDATE_BULK_DATA = "tractorUpdateBulkData"
export const TRACTOR_BULK_BOOKING_SENT_FOR_APPROVAL = "tractorBulkBookingSentForApproval"
export const TRACTOR_UPDATE_BOOKING_NO = "tractorUpdateBookingNo"
export const TRACTOR_UPDATE_BOOKING_QTY = "tractorUpdateBookingQty"
export const TRACTOR_UPDATE_BOOKING_CONTAINER_QTY = "tractorUpdateBookingContainerQty"

export const AGGREGATE_BOOKING_LOADED = "aggregateBookingLoad"
export const AGGREGATE_BOOKING_DONE = "aggregateBookingDone"
export const AGGREGATE_BOOKING_UPDATED = "aggregateBookingUpdated"
export const AGGREGATE_BOOKING_UPDATED_FOR_INSPECTION = "aggregateBookingUpdatedForInspection"
export const AGGREGATE_BOOKING_SENT_FOR_APPROVAL = "aggregateBookingSentForApproval"
export const AGGREGATE_BOOKING_STATUS_UPDATE_FROM_JD = "aggregateBookingStatusUpdateFromJD"
export const AGGREGATE_COLUMN_UPDATED = "aggregateColumnUpdated"
export const AGGREGATE_COLUMN_UPDATED_FOR_INSPECTION = "aggregateColumnUpdatedForInspection"
export const AGGREGATE_PLANNING_DONE = "aggregatePlanningDone"
export const AGGREGATE_INSERT_DROPDOWN_DATA = "aggregateInsertDropdownData"
export const AGGREGATE_DELETE_SUBROW = "aggregateDeleteSubrow"
export const AGGREGATE_UPDATE_BULK_DATA = "aggregateUpdateBulkData"
export const AGGREGATE_UPDATE_BOOKING_NO = "aggregateUpdateBookingNo"
export const AGGREGATE_UPDATE_BOOKING_QTY = "aggregateUpdateBookingQty"
export const AGGREGATE_UPDATE_BOOKING_CONTAINER_QTY = "aggregateUpdateBookingContainerQty"


export const FIVE_M_BOOKING_LOADED = "fiveMBookingLoad"
export const FIVE_M_BOOKING_DONE = "fiveMBookingDone"
export const FIVE_M_BOOKING_UPDATED = "fiveMBookingUpdated"
export const FIVE_M_BOOKING_UPDATED_FOR_INSPECTION = "fiveMBookingUpdatedForInspection"
export const FIVE_M_BOOKING_SENT_FOR_APPROVAL = "fiveMBookingSentForApproval"
export const FIVE_M_BOOKING_STATUS_UPDATE_FROM_JD = "fiveMBookingStatusUpdateFromJD"
export const FIVE_M_COLUMN_UPDATED = "fiveMColumnUpdated"
export const FIVE_M_COLUMN_UPDATED_FOR_INSPECTION = "fiveMColumnUpdatedForInspection"
export const FIVE_M_PLANNING_DONE = "fiveMPlanningDone"
export const FIVE_M_INSERT_DROPDOWN_DATA = "fiveMInsertDropdownData"
export const FIVE_M_DELETE_SUBROW = "fiveMDeleteSubrow"
export const FIVE_M_UPDATE_BULK_DATA = "fiveMUpdateBulkData"
export const FIVE_M_UPDATE_BOOKING_NO = "fiveMUpdateBookingNo"
export const FIVE_M_UPDATE_BOOKING_QTY = "fiveMUpdateBookingQty"
export const FIVE_M_UPDATE_BOOKING_CONTAINER_QTY = "fiveMUpdateBookingContainerQty"

export const PORTWISE_REPORT_LOADING = "portwiseReportLoading"

export const TRANSPORTER_LOADING = "transporterLoading"
export const TRANSPORTER_DELETE_ROW = "transporterDeleteRow"

export const CONTAINERMASTER_EMAIL_DATA = "containerMasterEmailData"
export const UPDATE_CONTAINERMASTER_EMAIL_DATA_TRACTOR = "updateContainerMasterEmailDataTractor"
export const UPDATE_CONTAINERMASTER_EMAIL_DATA_AGGREGATE = "updateContainerMasterEmailDataAggregate"
export const UPDATE_CONTAINERMASTER_EMAIL_DATA_5M = "updateContainerMasterEmailData5M"

export const ARRIVAL_REPORT_LOAD = "arrivalReportLoad"
export const ARRIVAL_REPORT_GATE_IN = "arrivalReportGateIn"
export const ARRIVAL_DELETE_ROW = "arrivalDeleteRow"

export const DISCHARGE_REPORT_LOAD = "dischargeReportLoad"
export const DISCHARGE_REPORT_GATE_OUT = "dischargeReportGateIn"

export const CONTAINER_GATE_OUT = "containerGateOut"
export const CONTAINER_DATA_LOAD = "loadContainerData"
export const ADD_CONTAINER_DATA = "addContainerData"
export const CONTAINER_DELETE_ROW = "containerDeleteRow"
export const CONTAINER_UPDATE_BACK_TO_TOWN = "containerUpdateBackToTown"

export const CONTAINER_SWAP_ROW_DATA = "containerSwapRowData"
export const CONTAINER_SWAP_DATA = "containerSwapData"


export const VGM_DATA_LOAD = "loadVGMData"
export const ADD_VGM_DATA = "addVGMData"
export const VGM_DELETE_ROW = "VGMDeleteRow"
export const VGM_EMAIL_DATA = "VGMEmailData"
export const UPDATE_VGM_EMAIL_DATA_TRACTOR = "updateVGMEmailDataTractor"
export const UPDATE_VGM_EMAIL_DATA_AGGREGATE = "updateVGMEmailDataAggregate"
export const UPDATE_VGM_EMAIL_DATA_5M = "updateVGMEmailData5M"

export const DAILY_PLAN_EMAIL_DATA = "dailyPlanEmailData"
export const UPDATE_DAILY_PLAN_EMAIL = "updateDailyPlanEmailData"

export const LOAD_INVOICE_PACKING_DOC = "loadInvoicePackingDoc"
export const DELETE_INVOICE_PACKING_DOC = "deleteInvoicePackingDoc"
export const INVOICEPACKING_EMAIL_DATA = "InvoicePackingEmailData"
export const UPDATE_INVOICEPACKING_EMAIL_DATA_TRACTOR = "updateInvoicePackingEmailDataTractor"
export const UPDATE_INVOICEPACKING_EMAIL_DATA_AGGREGATE = "updateInvoicePackingEmailDataAggregate"
export const UPDATE_INVOICEPACKING_EMAIL_DATA_5M = "updateInvoicePackingEmailData5M"

export const LOAD_USER_ACCESS = "loadUserAccess"

export const TRACTOR_ETA_DATA_LOADING="tractorEtaLoading"
export const TRACTOR_ETA_DELETE_ROW="tractorEtaDeleteRow"

export const AGGREGATE_ETA_DATA_LOADING = "aggregateEtaLoading"
export const AGGREGATE_ETA_DELETE_ROW = "aggregateEtaDeleteRow"

export const EMAIL_RECEPIENTS = "emailRecepients"
export const SET_CARRIER_DASHBOARD_DATA = "SET_CARRIER_DASHBOARD_DATA";



